import { Injectable, OnDestroy } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { BehaviorSubject } from 'rxjs';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  private readonly SESSION_KEY = 'userSession';
  private active = new BehaviorSubject<boolean>(true);
  public active$ = this.active.asObservable();
  private isDirty = false;
  private sessionTimeout = 20 * 60 * 1000; // 30 minutes
  constructor(private keycloakservice:KeycloakService,private notifServ:NotificationService) {
    this.trackActivity();
  }

  private trackActivity() {
    // Reset activity status on user activity
    this.resetActivityStatus();

    // Listen to various user activity events
    window.addEventListener('mousemove', this.resetActivityStatus.bind(this));
    window.addEventListener('keydown', this.resetActivityStatus.bind(this));
    window.addEventListener('scroll', this.resetActivityStatus.bind(this));
    window.addEventListener('click', this.resetActivityStatus.bind(this));
    // Check activity status periodically
    setInterval(() => {
      if (!this.active.getValue()) {
        this.handleInactivity();
      }
    }, 60000); // Check every minute
  }

  private resetActivityStatus() {
    this.active.next(true);
    setTimeout(() => this.active.next(false), 30000); // Set timeout to determine inactivity
  }

  private handleInactivity() {
    // Handle inactivity, e.g., redirect to a login page or show an alert
    // console.log('User is inactive');
    this.initializeSession();
  }

  private initializeSession() {
    const lastActiveTime = localStorage.getItem(this.SESSION_KEY);
    if (lastActiveTime) {
      const now = new Date().getTime();
      const lastActive = parseInt(lastActiveTime, 10);
      if (now - lastActive > this.sessionTimeout) {
        this.clearSession();
        console.log('Session has expired.');
        //  alert("There is no Acitivity for a while. So we close the session.");
        this.notifServ.confirmation("There is no Activity for a while. So we close the Session.",
          "N","Relogin",
          () => {
            this.keycloakservice.logout();
          },
          'Session Timeout',
          () => { })
      } 
    } 
  }
  public clearSession() {
    localStorage.removeItem(this.SESSION_KEY);
  }


}
